<div class="ring-loader">
  <div class="ring-loader__ring" [class.ring-loader__ring--spinning]="progress() === null"
       [style.width.px]="size()" [style.height.px]="size()">
    <svg [attr.viewBox]="'0 0 ' + size() + ' ' + size()">
      <circle class="ring-loader__track"
        [attr.cx]="size() / 2" [attr.cy]="size() / 2" [attr.r]="radius()" />
      <circle class="ring-loader__progress"
        [attr.cx]="size() / 2" [attr.cy]="size() / 2" [attr.r]="radius()"
        [attr.stroke-dasharray]="circumference()"
        [attr.stroke-dashoffset]="dashOffset()" />
    </svg>
  </div>
  @if (text()) {
    <span class="ring-loader__text">{{ text() }}</span>
  }
</div>
